import { FC, MouseEvent } from 'react'
import styled, { css } from 'styled-components'
import { DutyOrderField } from 'generated/graphql'

export type TOptionsValue = {
  label: string
  value: DutyOrderField
}

interface IFProps {
  options: Array<TOptionsValue>
  onClick: (value: TOptionsValue) => void
}

const SelectOption: FC<IFProps> = ({ options, onClick }) => {
  const handleClick = (e: MouseEvent<HTMLLIElement>) => {
    onClick({
      value: e.currentTarget.dataset.selectValue as DutyOrderField,
      label: e.currentTarget.dataset.selectLabel || '',
    })
  }

  return (
    <StyledWrapper>
      {options.map((option) => {
        return (
          <li
            key={`option-id-${option.value}`}
            onClick={handleClick}
            data-select-value={option.value}
            data-select-label={option.label}
          >
            <p>{option.label}</p>
          </li>
        )
      })}
    </StyledWrapper>
  )
}

export default SelectOption

const StyledWrapper = styled.ul`
  ${({ theme }) => css`
    width: 100%;
    height: fit-content;
    max-height: 320px;
    overflow-y: auto;
    border: solid 1px ${theme.line.line_1};
    border-radius: 8px;
    background-color: ${theme.background.bg_8};
    position: absolute;
    left: 0;
    top: 44px;
    z-index: 10;

    & > li {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 10px 15px;

      &:hover {
        background-color: ${theme.background.bg_3};
      }

      p {
        height: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        letter-spacing: -0.56px;
        text-align: left;
        color: ${theme.color.text_1};

        &:not(:first-child) {
          margin-left: 5px;
        }
      }
    }
  `}
`
